module.exports = __webpack_public_path__ + "static/emma-watson-8f8fa59e970102113d2e04cf9d6c95da.jpg";